import { Text } from 'components';
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const LoginFooter = () => {
  const { t } = useTranslation();
  const openRefundPolicy = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const width = 800;
    const height = 800;
    const left = window.screen.width / 2 - width / 2;
    const top = window.screen.height / 2 - height / 2;
    window.open(
      '/refund-policy',
      'RefundPolicy',
      `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`
    );
  };

  return (
    <footer className="relative bottom-0 flex w-full flex-col items-center justify-between bg-bg-layer2 bg-opacity-100 p-4 md:flex-row">
      <div className="flex flex-row gap-4">
        <Link to="/privacy-policy">
          <Text size="body2" color="description" weight="regular">
            {t('footer.privacy')}
          </Text>
        </Link>
        <Link to="/terms-of-service">
          <Text size="body2" color="description" weight="regular">
            {t('footer.terms')}
          </Text>
        </Link>
        <Link to="/refund-policy" onClick={openRefundPolicy}>
          <Text size="body2" color="description" weight="regular">
            {t('footer.refund')}
          </Text>
        </Link>
      </div>
      <Text size="body2" color="description" weight="regular">
        © 2024 Copyright IOPS. All rights reserved
      </Text>
    </footer>
  );
};

export default LoginFooter;
